import React, { useState, useEffect } from 'react';
import './PrivadaCopal.scss';
import RecorridoCopal from '../RecorridoCopal/RecorridoCopal';
import AmenidadesCopal from '../AmenidadesCopal/AmenidadesCopal';
import AmenidadesDescCopal from '../AmenidadesDescCopal/AmenidadesDesc';
import { useTranslation } from 'react-i18next';

const PrivadaCopal = () => {
  const { t } = useTranslation();
  const [showStiky, setShowStiky] = useState('ocultar');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div id="amenmapa" className='contenedor_home_copal_desc'>
        <img className='contenedor_home_copal_fondo' src="/assets/Artemisa/img-cover-privada-artemisa.jpg" alt="" />
        <div className='contenedor_home_copal__slider_card_logo'>
          <div className="contenedor-home-principal-copal">
            <img src="/assets/logo-P-COPAL.png" alt="Logo Copal" />
            <div className='button_dispo_copal'>
              <a href='https://disponibilidad.velasur.mx/privada-copal'>
                {t('buttons.seeAvailability')}
              </a>
            </div>
          </div>   
        </div>
        <a
          id="ws_script"
          href="https://api.whatsapp.com/send?phone=524428801675&text"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://multipagos.velasresorts.com/images/WhatsApp_Logo_1.png"
            width="65"
            height="65"
            alt="WhatsApp"
          />
        </a>
      </div>
      <RecorridoCopal/>
      <AmenidadesCopal/>
      <AmenidadesDescCopal/>
    </>
  );
}
export default PrivadaCopal;

